import { useNavigate } from "react-router-dom";
import { useApp } from "@/App";
import { GAMES_GRID } from "@/lib/gamesConfig";

const GamesPage = () => {
  const navigate = useNavigate();
  const { haptic } = useApp();

  const handleOpenGame = (path) => {
    haptic("light");
    navigate(path);
  };

  return (
    <div className="games-page animate-fade-in" data-testid="games-page">
      <section className="games-hero">
        <div className="games-hero-title" aria-hidden="true">GAMES</div>
      </section>

      <section className="games-grid-wrap">
        <div className="games-grid" role="list">
          {GAMES_GRID.map((game) => (
            <button
              key={game.id}
              type="button"
              role="listitem"
              className="games-card"
              onClick={() => handleOpenGame(game.path)}
              data-testid={`game-tile-${game.id}`}
            >
              <img
                src={game.image}
                alt={game.title}
                className="games-card-image"
                loading="lazy"
              />
            </button>
          ))}
        </div>
      </section>
    </div>
  );
};

export default GamesPage;
